"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ovaro": {
    "5ba43770": [{
      "hkey": "a087f7ec",
      "slug": "ovaro",
      "name": "Ovaro",
      "primary": true,
      "skipSearch": false
    }],
    "chialina": [{
      "hkey": "a087f7ec",
      "slug": "ovaro",
      "name": "Ovaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e9401e0c": [{
      "hkey": "733065bb",
      "slug": "cludinico",
      "name": "Cludinico",
      "primary": true,
      "skipSearch": false
    }],
    "cludinicco": [{
      "hkey": "733065bb",
      "slug": "cludinico",
      "name": "Cludinico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cda6dba5": [{
      "hkey": "a087f7ec",
      "slug": "ovaro",
      "name": "Ovaro",
      "primary": true,
      "skipSearch": false
    }],
    "lenzone": [{
      "hkey": "a087f7ec",
      "slug": "ovaro",
      "name": "Ovaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;